export const environment = {
  production: false,
  mockMode: false,
  apiBaseUrl: 'https://appli-back-qualif.logiciels-carbone14.fr',
  auth: {
    backOfficeUrl: 'https://appli-back-qualif.logiciels-carbone14.fr',
    authContextPath: '/auth',
    clientId: 'carbone14f',
    clientSecret: 'Partner1',
  },
};
